// Fire-and-forget page-view tracking. A raw fetch rather than the axios client
// so the request can carry keepalive (it completes even if the user navigates
// away mid-flight) and so its failure can never surface: no interceptors, no
// toasts, no sign-out redirect. The JWT rides on the session cookie.
export function trackUsage(page: string): void {
  try {
    const env = (window as unknown as { _env_?: { REACT_APP_API_BASE_URL?: string } })._env_;
    const base = (env?.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
    void fetch(`${base}/usage/track`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page }),
      keepalive: true,
    }).catch(() => {
      /* logging must never affect the UI */
    });
  } catch {
    /* same: a browser without fetch/keepalive support just goes untracked */
  }
}
